import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { CancellationPolicy } from 'shared/api/kyrgyzstan/search/model'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Paper } from 'shared/ui/paper'

import { formatExelyCancellationDeadline } from './lib/format-exely-cancellation-deadline'
import s from './styles.module.scss'

interface CancelWarningExelyProps {
  cancellationPolicy?: CancellationPolicy | null
  penaltyAmount?: string
  currencyCode?: string
}

export const CancelWarningExely = ({
  cancellationPolicy,
  penaltyAmount,
  currencyCode,
}: CancelWarningExelyProps) => {
  const { t } = useTranslation()
  console.log(
    'cancellationPolicy',
    cancellationPolicy?.free_cancellation_deadline_local,
  )
  if (!cancellationPolicy) return null

  const deadline = formatExelyCancellationDeadline(
    cancellationPolicy.free_cancellation_deadline_local,
  )
  const hasTimezone = Boolean(cancellationPolicy.timezone)
  const timezone = hasTimezone
    ? t('kyrgyzstan_block.timezone', {
        timezone: cancellationPolicy.timezone,
      })
    : undefined

  return (
    <Paper
      padding={[12]}
      radius="12px"
      className={clsx(s.warningBlock)}
    >
      <div className={s.warningContent}>
        <AppIcon
          id={AllIcons.INFO_TRIANGLE}
          width={24}
          height={24}
          className={s.warningIcon}
        />
        <div className={s.warningText}>
          <p className={clsx('bold-12', s.warningTitle)}>
            {t('kyrgyzstan_block.cancel_booking_info.warning.exely.title')}
          </p>

          <div className={s.info}>
            <p className={clsx('medium-12', s.item)}>
              {t(
                hasTimezone
                  ? 'kyrgyzstan_block.cancel_booking_info.warning.exely.description_with_timezone'
                  : 'kyrgyzstan_block.cancel_booking_info.warning.exely.description',
                {
                  cancellation: {
                    date: deadline?.date ?? '-',
                    hours: deadline?.hours ?? '-',
                    timezone,
                  },
                },
              )}
            </p>

            {penaltyAmount && (
              <p className={clsx('medium-12', s.item)}>
                {t(
                  'kyrgyzstan_block.cancel_booking_info.warning.exely.penalty',
                  {
                    cancellation: {
                      penalty: penaltyAmount,
                      currency: currencyCode,
                    },
                  },
                )}
              </p>
            )}
          </div>
        </div>
      </div>
    </Paper>
  )
}
